import { createFormFields } from '@/shared/components/form-fields/factories/create-form-fields';
import { useFieldContext } from './proposal-decision-form-context.hook';

export const ProposalAnalysisFormFields = createFormFields(useFieldContext);
